import sprae, { use } from "./sprae.js"; import * as signals from "@preact/signals-core"; use(signals); export * from "./sprae.js"; export default sprae